// Central WhatsApp / phone config so we can change the number in one place.
export const WA_NUMBER = "14163153679"; // (416) 315-3679, no spaces, no plus, for wa.me URLs
export const WA_DISPLAY = "(416) 315-3679";
export const PHONE_HREF = "tel:+14163153679";

export const waLink = (message = "Hi, I saw AlwaysInsured.ca and want a free insurance quote.") =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;
